var map = {
	"./datajson/unidad1/mod1-1": "2449",
	"./datajson/unidad1/mod1-1.json": "2449",
	"./datajson/unidad2/carrusel": "82f3",
	"./datajson/unidad2/carrusel.json": "82f3",
	"./fondo/textura-2.svg": "f904",
	"./fonts/SourceSansPro-Black.ttf": "c7d4",
	"./fonts/SourceSansPro-BlackItalic.ttf": "283b",
	"./fonts/SourceSansPro-Bold.ttf": "2fce",
	"./fonts/SourceSansPro-BoldItalic.ttf": "0a02",
	"./fonts/SourceSansPro-ExtraLight.ttf": "3a7d",
	"./fonts/SourceSansPro-ExtraLightItalic.ttf": "4328",
	"./fonts/SourceSansPro-Italic.ttf": "2d17",
	"./fonts/SourceSansPro-Light.ttf": "7cd1",
	"./fonts/SourceSansPro-LightItalic.ttf": "da3c",
	"./fonts/SourceSansPro-Regular.ttf": "8f14",
	"./fonts/SourceSansPro-SemiBold.ttf": "bab5",
	"./fonts/SourceSansPro-SemiBoldItalic.ttf": "14c4",
	"./glosario": "4607",
	"./glosario.json": "4607",
	"./imagenes_compartidas/12 boton saltar pregunta.png": "5624",
	"./imagenes_compartidas/12 boton saltar pregunta.svg": "d070",
	"./imagenes_compartidas/13-icono-retroalimentacion-BIEN.png": "72a4",
	"./imagenes_compartidas/14-icono-retroalimentacion-MAL.png": "b956",
	"./imagenes_compartidas/9-logo-interno.png": "0efb",
	"./imagenes_compartidas/BOTON-ANTERIOR-OVER.svg": "690a",
	"./imagenes_compartidas/BOTON-ANTERIOR.svg": "9465",
	"./imagenes_compartidas/BOTON-SIGUIENTE-OVER.svg": "44e7",
	"./imagenes_compartidas/BOTON-SIGUIENTE.svg": "6a62",
	"./imagenes_compartidas/Boton-de-cierre.svg": "3b64",
	"./imagenes_compartidas/boton-descarga.png": "db39",
	"./imagenes_compartidas/check.png": "15cb",
	"./imagenes_compartidas/icon-descarga.svg": "2086",
	"./imagenes_compartidas/icon-titulo.png": "6ddf",
	"./imagenes_compartidas/icon-ul-a.svg": "d73c",
	"./imagenes_compartidas/logo-ecopetrol-w.png": "9e02",
	"./imagenes_compartidas/logo-ecopetrol.svg": "b7f7",
	"./imagenes_compartidas/logos/logo-1.png": "c071",
	"./imagenes_compartidas/logos/logo-2.png": "f9b6",
	"./imagenes_compartidas/logos/logo-3.png": "4432",
	"./imagenes_compartidas/mal-bot-gran.png": "1c62",
	"./imagenes_compartidas/menu-icon.svg": "f831",
	"./imagenes_compartidas/personaje-0.png": "5b2b",
	"./imagenes_compartidas/personaje-1.png": "f198",
	"./mod9": "dcf0",
	"./mod9.json": "dcf0",
	"./modulos/navegacion": "ec32",
	"./modulos/navegacion.json": "ec32",
	"./presentacion/1Fondoportada.svg": "71b3",
	"./presentacion/3 titulo portada.svg": "da0e",
	"./presentacion/4 boton inicio portada.svg": "ba18",
	"./presentacion/5-logo-portada-mobiles.png": "3d96",
	"./presentacion/5-logo-portada.png": "32cf",
	"./presentacion/estrellas-background.png": "f22e",
	"./presentacion/modulo-1.svg": "023d",
	"./presentacion/modulo-2.svg": "f8c7",
	"./presentacion/modulo-3.svg": "47b7",
	"./presentacion/modulo-4.svg": "ec3a",
	"./presentacion/modulo-5.svg": "aa771",
	"./presentacion/portada-1.png": "28e1",
	"./textos_proyecto": "fe8a",
	"./textos_proyecto.json": "fe8a",
	"./unidad1/pantalla 6-1 mobile.svg": "5f94",
	"./unidad1/pantalla 6-3.svg": "1a6d",
	"./unidad1/pantalla 7-1 mobile.svg": "5b30",
	"./unidad1/pantalla-10-1.png": "3d90",
	"./unidad1/pantalla-4-2.png": "3f7f",
	"./unidad1/pantalla-4-3.png": "32ce",
	"./unidad1/pantalla-4-4.png": "51c2",
	"./unidad1/pantalla-4-5.png": "4268",
	"./unidad1/pantalla-4-6--mobile.png": "e854",
	"./unidad1/pantalla-4-6-boton-1-check.png": "5000",
	"./unidad1/pantalla-4-6-boton-1.png": "1af5",
	"./unidad1/pantalla-4-6-boton-2-check.png": "5190",
	"./unidad1/pantalla-4-6-boton-2.png": "a37d",
	"./unidad1/pantalla-4-6.png": "7d27",
	"./unidad1/pantalla-5-1.png": "e8e6",
	"./unidad1/pantalla-6-1-1.png": "530a",
	"./unidad1/pantalla-6-1-2.png": "a725",
	"./unidad1/pantalla-6-1.png": "013b",
	"./unidad1/pantalla-6-2-1.png": "687c",
	"./unidad1/pantalla-6-2-2.png": "c2dc",
	"./unidad1/pantalla-6-3-1.png": "7dfd",
	"./unidad1/pantalla-6-3-2.png": "7e8e",
	"./unidad1/pantalla-8-1.png": "adfb",
	"./unidad1/pantalla-8-2.png": "e48e",
	"./unidad1/pantalla-8-3.png": "5d32",
	"./unidad1/pantalla-8-4.png": "aa33",
	"./unidad1/pantalla-8-5.png": "0fdd",
	"./unidad1/pantalla-8-6.png": "3a52",
	"./unidad1/pantalla-8-7.png": "c7e2",
	"./unidad1/pantalla-9-1.png": "1592",
	"./unidad1/pantalla-9-10.png": "0806",
	"./unidad1/pantalla-9-11.png": "1d8d",
	"./unidad1/pantalla-9-12.png": "f995",
	"./unidad1/pantalla-9-2.png": "5bc3",
	"./unidad1/pantalla-9-3.png": "8e52",
	"./unidad1/pantalla-9-4.png": "6224",
	"./unidad1/pantalla-9-5.png": "ba13",
	"./unidad1/pantalla-9-6.png": "9346",
	"./unidad1/pantalla-9-7.png": "93f9",
	"./unidad1/pantalla-9-8.png": "aa1a",
	"./unidad1/pantalla-9-9.png": "5cb8",
	"./unidad1/pregunta-10.png": "19a5",
	"./unidad1/pregunta-4.png": "70fc",
	"./unidad2/Icono (1).svg": "c1f2",
	"./unidad2/Icono1-1.png": "72ce",
	"./unidad2/Icono1-2.png": "1d36",
	"./unidad2/Iconodg-1.png": "de62",
	"./unidad2/Iconodg-2.png": "798e",
	"./unidad2/Iconodg-3.png": "8c12",
	"./unidad2/Iconodg-4.png": "0b74",
	"./unidad2/Iconodg-5.png": "842f",
	"./unidad2/Iconodg-6.png": "6948",
	"./unidad2/Iconodg-7.png": "2f4e",
	"./unidad2/boton Nuevamente.svg": "a118",
	"./unidad2/boton comprobar.svg": "6559",
	"./unidad2/img1.png": "5ee3",
	"./unidad2/img2.png": "560b",
	"./unidad2/img3.png": "9e5b",
	"./unidad2/img4.png": "1f7b",
	"./unidad2/img5.png": "4a93",
	"./unidad2/img6.png": "2798",
	"./unidad2/img7.png": "d7df",
	"./unidad2/img8.png": "107e",
	"./unidad2/pantalla 4-1 mobile.svg": "a607",
	"./unidad2/pantalla 4-1.svg": "6388",
	"./unidad2/pantalla 5-1.svg": "7569",
	"./unidad2/pantalla 5-4.svg": "07af",
	"./unidad2/pantalla 6-8.svg": "c876",
	"./unidad2/pantalla 7-1 mobile.svg": "f6d1",
	"./unidad2/pantalla 7-1.svg": "6fda",
	"./unidad2/pantalla 7-11.svg": "5323",
	"./unidad2/pantalla-1-1-slider.png": "a88b",
	"./unidad2/pantalla-1-1.png": "6e23",
	"./unidad2/pantalla-1-10.png": "d445",
	"./unidad2/pantalla-1-13.png": "56ea",
	"./unidad2/pantalla-1-2.png": "afa1",
	"./unidad2/pantalla-1-3-1.png": "ae12",
	"./unidad2/pantalla-1-3-2.png": "c51c",
	"./unidad2/pantalla-1-3-3.png": "3655",
	"./unidad2/pantalla-1-3.png": "73cf",
	"./unidad2/pantalla-1-4.png": "4719",
	"./unidad2/pantalla-1-8.png": "1376",
	"./unidad2/pantalla-1-9.png": "1179",
	"./unidad2/pantalla-2-1.png": "b280",
	"./unidad2/pantalla-2-10.png": "3e66",
	"./unidad2/pantalla-2-11.png": "bc92",
	"./unidad2/pantalla-2-12.png": "cf5b",
	"./unidad2/pantalla-2-2.png": "192a",
	"./unidad2/pantalla-2-3.png": "f062",
	"./unidad2/pantalla-2-4.png": "1a55",
	"./unidad2/pantalla-2-5.png": "551c",
	"./unidad2/pantalla-2-6.png": "b20b",
	"./unidad2/pantalla-2-7.png": "188d",
	"./unidad2/pantalla-2-8.png": "1d30",
	"./unidad2/pantalla-2-9.png": "2eb1",
	"./unidad2/pantalla-2-sliders.png": "ddf3",
	"./unidad2/pantalla-3-1-10.png": "3b8c",
	"./unidad2/pantalla-3-2.png": "afc9",
	"./unidad2/pantalla-3-3.png": "63c3",
	"./unidad2/pantalla-3-4.png": "1218",
	"./unidad2/pantalla-3-5.png": "b596",
	"./unidad2/pantalla-3-6.png": "51c8",
	"./unidad2/pantalla-4-1-mobile.png": "7729",
	"./unidad2/pantalla-4-1.png": "0407",
	"./unidad2/pantalla-6-1.png": "3faa",
	"./unidad2/pantalla-6-2.png": "273e",
	"./unidad2/pantalla-6-3.png": "a357",
	"./unidad2/pantalla-6-4.png": "0b52",
	"./unidad2/pantalla-6-5.png": "bd8b",
	"./unidad2/pantalla-6-6.png": "0673",
	"./unidad2/pantalla-6-7.png": "caee",
	"./unidad2/pantalla-6-8.png": "1fd2",
	"./unidad2/pantalla-6-9.png": "0a8e",
	"./unidad2/pantalla-7-1-mobile.png": "5bd9",
	"./unidad2/pantalla-7-1.png": "69ed",
	"./unidad2/pantalla-7-2.png": "4d7e",
	"./unidad2/pantalla-7-3.png": "5c1e",
	"./unidad2/pantalla-7-4.png": "c37c",
	"./unidad2/pantalla-7-5.png": "d5a5",
	"./unidad2/pantalla-7-6.png": "21b8",
	"./unidad2/pantalla-7-7.png": "09b9",
	"./unidad2/pantalla-7-8.png": "eecf",
	"./unidad2/pantalla-8-mobile.png": "49dc",
	"./unidad2/pantalla1-1.png": "871a",
	"./unidad2/pantalla1-2.png": "eebd",
	"./unidad2/pantalla1-3.png": "df1a",
	"./unidad2/pantalla2-1.png": "fd2a",
	"./unidad2/pantalla2-2.png": "5ddb",
	"./unidad2/pantalla2-3.png": "ea8b",
	"./unidad2/pantalla2-4.png": "44d8",
	"./unidad2/pantalla2-5.png": "98fd",
	"./unidad2/pantalla2-6.png": "e534",
	"./unidad2/pantalla2-7.png": "c942",
	"./unidad2/pantalla6-1.png": "59ff",
	"./unidad2/pantalla6-2.png": "b79b",
	"./unidad2/pantalla6-3.png": "adbd",
	"./unidad2/pantalla6-4.png": "7588",
	"./unidad2/pantalla7-1.png": "28fe",
	"./unidad2/pregunta-4.png": "b4b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";